import { useId } from 'react';
import ChangePasswordForm from './components/ChangePasswordForm/ChangePasswordForm';
import PasswordInput from './components/PasswordInput/PasswordInput';
import { passwordFields } from './config/changePassword.config';
import useChangePassword from './hooks/useChangePassword';

const ChangePassword = ({ isClassic = false, onBack }) => {
  const { passwords, updatePassword, ...workflow } = useChangePassword();
  const formId = useId();

  return (
    <ChangePasswordForm {...workflow} onBack={onBack} isClassic={isClassic}>
      {passwordFields.map(({ id, label }) => (
        <PasswordInput
          key={id}
          controlId={`${formId}-${id}`}
          label={label}
          backgroundColor={isClassic ? undefined : 'var(--color-base)'}
          value={passwords[id]}
          onChange={(value) => updatePassword(id, value)}
        />
      ))}
    </ChangePasswordForm>
  );
};

export default ChangePassword;
